// extracted by mini-css-extract-plugin
module.exports = {"button":"_2f89dd80","inlineSpinner":"_8f78ae42"};